export const ROW_NUM_COL_ID = 'rowNum';

export const ARROW_KEY = {
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight'
} as const;

export const ARROW_KEYS: Set<string> = new Set(Object.values(ARROW_KEY));

export const SELECTION_THEME_PARAMS = {
  borderRadius: 0,
  selectedRowBackgroundColor: 'transparent',
  cellFocusOutlineColor: 'transparent',
  rowHoverColor: 'transparent',
  cellEditingBorder: 'transparent',
  cellEditingShadow: 'transparent'
};

/** Zoom presets in percent. */
export const GRID_ZOOM_LEVELS = [50, 75, 90, 100, 125, 150, 200] as const;

export const DEFAULT_GRID_ZOOM = 100;

/** Base Quartz theme values — scaling these scales the whole grid. */
export const GRID_BASE_METRICS = {
  spacing: 8,
  fontSize: 14,
  iconSize: 16
} as const;

/** Max rows per Add Variant action. */
export const MAX_VARIANTS_PER_ADD = 500;

/** Max total variant rows per template. */
export const MAX_TOTAL_VARIANTS = 2000;

/** Selectors whose clicks should not clear the grid selection. */
export const SELECTION_SAFE_SELECTOR =
  '.variant-grid-toolbar, .v-overlay-container';
